import Model from 'src/app/common/model';
import DeviceModel from './device.model';
import SrTopicsModel from './srTopics.model';
import SrStatusCodesModel from './srStatusCodes.model';
import BusinessEntity from './businessEntity.model';
import PersonsModel from './persons.model';

export default class ServiceRequestModel extends Model {
  device: DeviceModel;
  srTopics: SrTopicsModel;
  ssCode: SrStatusCodesModel;
  BusinessDetails: Array<BusinessEntity>;
  personDetails: Array<PersonsModel>;
  description?: string;
  sr_start_date: Date;
  farm_site_id?: string;
  business_id?: string;
  person_id?: string;
  assignedTo?: string;
  device_id: string;
  ss_code_id: number;
  topic_id: number;
  sr_end_date?: Date;
  sr_action_desc?: string;
  userMail: string;
  created_by: string;
  updated_by: string;

  constructor() {
    super();
    this.BusinessDetails = new Array();
    this.personDetails = new Array();
  }
}
